import { createReducer } from '../utils';

import {
	RETRIEVE_USER_REQUEST,
	RETRIEVE_USER_SUCCESS,
	RETRIEVE_USER_FAILURE
} from '../user';

export default createReducer(false, {
	[RETRIEVE_USER_REQUEST]: (state, action) => true,
	[RETRIEVE_USER_SUCCESS]: (state, action) => false,
	[RETRIEVE_USER_FAILURE]: (state, action) => false
});

export function getIsRetrievingUser(state) {
	return state.app.isRetrievingUser;
}



// WEBPACK FOOTER //
// ./src/js/reducers/app/isRetrievingUser.js